import SignStoreConfig from './config'

export default {
  authenticationAccessToken: {},
  ifNewUser: localStorage.getItem(SignStoreConfig.LOCAL_STATES.IS_NEW_USER) === 'true',
  idDocumentLicenseKey: '',
  cosmosConnection: {},
  widgetConfig: {
    steps: {
      faceRecog: true,
      idOcr: true,
      onChainId: true,
      sbtMint: true,
    },
  },
  widgetConfigFromDb: null,
  steps: [],
  currentStepIndex: 0,
  schemaIds: {},
  idToken: '',
  authorization: null,
  environment: '',
  mobileFlowError: null,
  mobileFlowActive: false,
  mobileHandoffAuthenticated: false,
}
